import { createBrowserRouter } from "react-router-dom";
import { AttendancePage } from "./ui/pages/attendance/AttendancePage";
import { DoneAttendancePage } from "./ui/pages/attendance/DoneAttendancePage";
import { HomePage } from "./ui/pages/home/HomePage";
import { DeclineAttendancePage } from "./ui/pages/mourning-card/DeclineAttendancePage";

import { PrivacyPage } from "./ui/pages/privacy/PrivacyPage";
import { FuneralRSVPPage } from "./ui/pages/rsvp/FuneralRSVPPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/:funeralUuid/attendance",
    element: <AttendancePage />,
  },
  {
    path: "/stars/:starUuid/invite",
    element: <FuneralRSVPPage />,
  },
  {
    path: "/invite/decline",
    element: <DeclineAttendancePage />,
  },
  {
    path: "/invite/done",
    element: <DoneAttendancePage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: "*",
    element: <HomePage />,
  },
]);
